import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Core components
import TimePicker from 'components/core/TimePicker';
// Models
import { maxSlotEndMinutes, daysId, periodToEvent } from 'models/planning';
// Custom
import { dateGenerator, dateGetter } from 'utils/DateUtils';
import withFormManagement from 'hocs/WithFormManagement';
import ErrorsDisplayer from 'components/misc/ErrorsDisplayer';
import WeekSelectField from 'components/inputFields/WeekSelectField';

class PlanningPeriodEditForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleValidate = this.handleValidate.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidMount() {
    // We need to pass component reference to parent (= DialogItem)
    const { onRef } = this.props;
    onRef(this);
  }

  // Handlers called by parent (= DialogItem)
  handleValidate() {
    const {
      fields: {
        startDayId, startTime, endDayId, endTime,
      },
      onErrorsChange, onValidate,
    } = this.props;

    let computedEndDayId = endDayId;
    let computedEndTime = endTime;

    const startMinutesQuantity = dateGetter.minutesQuantity(startTime);
    let endMinutesQuantity = dateGetter.minutesQuantity(endTime);
    // Period finishes on monday 00:00 => accept it by transforming it in sunday 23:59
    if (endMinutesQuantity === 0 && endDayId === daysId.mo) {
      endMinutesQuantity = maxSlotEndMinutes - 1;
      computedEndDayId = daysId.su;
      computedEndTime = dateGenerator.dateSubtractor(computedEndTime, { minutes: 1 });
    }

    // Validate period
    let errors;
    if (
      (computedEndDayId < startDayId)
      || (computedEndDayId === startDayId && endMinutesQuantity <= startMinutesQuantity)
    ) {
      errors = { global: 'planningPeriodBeginEnd' };
    }
    // Apply errors
    onErrorsChange(errors);

    // No error => validate form
    if (!errors) {
      const start = { dayId: startDayId, time: startTime };
      const end = { dayId: computedEndDayId, time: computedEndTime };
      onValidate(periodToEvent({ start, end }));
      return true;
    }
    return false;
  }

  handleDelete() {
    const { onDelete } = this.props;
    onDelete();
    return true;
  }

  render() {
    const {
      fields: {
        startDayId, startTime, endDayId, endTime,
      }, errors,
      onFieldsChange,
    } = this.props;

    return (
      <div>
        <ErrorsDisplayer errors={errors} />
        <div className="row">
          <div className="col-12 col-md-6">
            <WeekSelectField
              labelId="field.beginDay"
              value={startDayId}
              onChange={(dayId) => onFieldsChange({ startDayId: dayId })}
            />
          </div>
          <div className="col-12 col-md-6">
            <TimePicker
              label={<LocalizedMessage id="field.beginTime" />}
              value={dateGenerator.date(startTime)}
              onChange={(time) => onFieldsChange({ startTime: time })}
            />
          </div>
          <div className="col-12 col-md-6">
            <WeekSelectField
              labelId="field.endDay"
              value={endDayId}
              onChange={(dayId) => onFieldsChange({ endDayId: dayId })}
            />
          </div>
          <div className="col-12 col-md-6">
            <TimePicker
              label={<LocalizedMessage id="field.endTime" />}
              value={dateGenerator.date(endTime)}
              onChange={(time) => onFieldsChange({ endTime: time })}
            />
          </div>
        </div>
      </div>
    );
  }
}

PlanningPeriodEditForm.propTypes = {
  period: PropTypes.shape({
    start: PropTypes.shape({
      dayId: PropTypes.number.isRequired,
      time: PropTypes.instanceOf(Date).isRequired,
    }).isRequired,
    end: PropTypes.shape({
      dayId: PropTypes.number.isRequired,
      time: PropTypes.instanceOf(Date).isRequired,
    }).isRequired,
  }).isRequired,
  fields: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onFieldsChange: PropTypes.func.isRequired,
  onErrorsChange: PropTypes.func.isRequired,
  onRef: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

PlanningPeriodEditForm.defaultProps = {
  errors: null,
};

const mapFieldsToProps = {
  startDayId: {
    resourceKey: 'start.dayId',
    defaultValue: null,
  },
  startTime: {
    resourceKey: 'start.time',
    defaultValue: null,
  },
  endDayId: {
    resourceKey: 'end.dayId',
    defaultValue: null,
  },
  endTime: {
    resourceKey: 'end.time',
    defaultValue: null,
  },
};

const mapOwnPropsToResources = (ownProps) => ({
  resourceData: ownProps.period,
});

module.exports = withFormManagement(mapFieldsToProps, mapOwnPropsToResources, false)(PlanningPeriodEditForm);



// WEBPACK FOOTER //
// ./components/plannings/PlanningPeriodEditForm.js